import { AbstractControl, ValidationErrors } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

export function SetupFeeValidator(control: AbstractControl, field: FormlyFieldConfig): ValidationErrors | null {
  const value = control.value;

  if (!value || typeof value !== 'object') {
    return null;
  }

  // Get setup fee fields for current currency
  const currency = field.props?.['currency'] || 'EUR';
  const setupFeePrice = value[`setupFeePrice${currency}`];
  const setupFeeStripePriceId = value[`setupFeeStripePriceId${currency}`];

  // If any setup fee field is filled, both must be filled
  const hasAnySetupFeeField = setupFeePrice || setupFeeStripePriceId;

  if (hasAnySetupFeeField) {
    const missingFields: string[] = [];

    if (!setupFeePrice || setupFeePrice <= 0) {
      missingFields.push(`Setup Fee Price (${currency})`);
    }

    if (!setupFeeStripePriceId || setupFeeStripePriceId.trim() === '') {
      missingFields.push(`Setup Fee Stripe Price ID (${currency})`);
    }

    if (missingFields.length > 0) {
      return {
        setupFeeRequiredFields: {
          currency,
          missingFields
        }
      };
    }
  }

  return null;
}